import { round } from 'lodash';
import styled from 'styled-components/macro';
import { Header2 } from '../../shared/Headers';
import { TBody, Td, Th, Tr } from '../../shared/Table';
import { ManifoldDiagramTable } from './manifold-diagram/ManifoldDiagramWithTable';
import { PdfDetailResponse } from './PdfDataResponse';

type Props = {
  hasHeatPump: boolean;
  pdfDetail: PdfDetailResponse;
};

export const SystemComponentSizingTable = ({
  hasHeatPump,
  pdfDetail: { boilerCapacityInKilowatts, totalWaterVolumeInLitres, expansionWaterVesselSizeInLitres },
}: Props) => {
  return (
    <SystemComponentSizingContainer>
      <Header2>System Component Sizing</Header2>
      <ComponentSizingTable>
        <TBody>
          <Tr>
            <Th scope="row">System Water Volume</Th>
            <Td>{round(totalWaterVolumeInLitres ?? 0, 1)} litres</Td>
          </Tr>
          <Tr>
            <Th scope="row">Expansion Vessel Sizing</Th>
            <Td>{round(expansionWaterVesselSizeInLitres ?? 0, 1)} litres</Td>
          </Tr>
          {!hasHeatPump && boilerCapacityInKilowatts != null && boilerCapacityInKilowatts > 0 && (
            <Tr>
              <Th scope="row">Boiler Sizing</Th>
              <Td>{boilerCapacityInKilowatts ?? ''} kW</Td>
            </Tr>
          )}
        </TBody>
      </ComponentSizingTable>
    </SystemComponentSizingContainer>
  );
};

const SystemComponentSizingContainer = styled.div`
  width: 100%;
`;

const ComponentSizingTable = styled(ManifoldDiagramTable)`
  width: 100%;
`;
